import { uniqueId } from 'lodash';
import myDataIcon from '../../images/links/foundation/icn_my_data.png';
import myTeamIcon from '../../images/links/foundation/icn_myteam.png';

const module = 'Foundation';

export default [
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_MyData',
    icon: myDataIcon,
    url: '/foundation/mydata',
    messageApi: null,
    sort: 11,
    functionCode: [
      'MyDataInformation',
      'MyDataContact',
      'MyDataEducation',
      'MyDataCertificate',
      'MyDataWork',
      'MyDataYOS',
      'MyDataExperience',
    ],
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_MyTeam',
    icon: myTeamIcon,
    url: '/foundation/myteam',
    messageApi: null,
    sort: 12,
    functionCode: 'MyTeam',
  },
];



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/Index/config/links/foundation.js
 **/